import { removeQuery, hasQueryStringParameter } from 'owa-querystring';
import { getWindowData } from 'owa-window-data';
import { handleFallbackScenariosForMSALAnonymous } from 'owa-msaljs/lib/utils/handleFallbackScenariosForMSALAnonymous';

export default function runBeforeStart() {
    // Presence of this query param is causing auth failure in some scenarios
    // There's a backend change to fix this, but it's not fully deployed yet
    // So we're removing the query param here for now and will remove the below code once the backend change is fully deployed
    if (hasQueryStringParameter('isAnonymous')) {
        const newSearch = removeQuery(getWindowData().location.search, 'isAnonymous');
        getWindowData().location.search = newSearch;
    }

    // Update any encoded components in the url.
    const url = getWindowData().location.href;
    const decodedUrl = decodeURIComponent(url);
    if (url != decodedUrl) {
        getWindowData().location.href = decodedUrl;
    }

    handleFallbackScenariosForMSALAnonymous();

    return Promise.resolve();
}
